import * as React from "react";
import { LayoutPage } from "../../components/Layout/layoutPage";
import TopBar from "../../components/TopBar/TopBar";
import { Pagination, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import { ModalCustom } from "../../components/Modal/modalsCustom";
import AgentiForm from "../../components/Formik/agentiForm";
import { ResetPass } from "../../components/Formik/FormikResetPass";
import CheckIcon from "@mui/icons-material/Check";
import { ModalEdit } from "../../components/Modal/ModalEdit";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import CustomizedSnackbars from "../../components/Message/Snackars";
import { I18n } from "../../i18n";
import translate from "../../i18n/messages/translate";
import Loading from "../../components/Loading/loading";
import { importBaseActions } from "../../store/reducers/base";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDataGridStyles, useDropDownMenuStyles, usePaginationStyles } from "../../core/MuiStyles";
import { ITEMS_PER_PAGE } from "../../Utility";
import { LoadingInternal } from "../../components/Loading/LoadingInternal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArchiveIcon from "@mui/icons-material/Archive";
import { useConfigurationsService } from "../../services/ConfigurationsService";
import { useCustomersService } from "../../v2/services/customers_service";
//card
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import AddReactionIcon from '@mui/icons-material/AddReaction';
import BuildIcon from '@mui/icons-material/Build';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
//Breadcrumbs
import Breadcrumbs from '@mui/material/Breadcrumbs';
import GridViewIcon from '@mui/icons-material/GridView';
import HomeIcon from "@mui/icons-material/Home";
import {useNavigationStack} from "../../v2/providers/NavigationContext";
//start
const DashboardAgents = () => {
  const location = useLocation();
  const configurationsService = useConfigurationsService();
  const customersService = useCustomersService();
  const { stack, goToStack } = useNavigationStack();
  const { push } = useNavigationStack();
  const baseActions = importBaseActions();
  const dispatch = useDispatch();
  const state = useSelector(state => state.base);
  const [rows, setRows] = useState({ pageSize: ITEMS_PER_PAGE, page: 0, items: [], pageCount: 0, isRefreshing: true });
  const { t } = useTranslation("common");
//go
function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}
  //const history = useHistory();
  const navigate = useNavigate();
  const paginationClasses = usePaginationStyles();
  const [user, setUser] = useState();
  const [open, setOpen] = useState(false);

  // HOOK EDIT BUTTON
  const [openEdit, setOpenEdit] = useState(false);
  const handleCloseEdit = () => {
    setOpenEdit(false);
    load(rows.page);
  }
  const handleOpenEdit = (user) => {
    setUser(user);
    setOpenEdit(true);
    closeUserMenu();
  };

  //HOOK RESET PASSWORD BUTTON
  const [openReset, setOpenReset] = useState(false);
  const handleCloseReset = () => setOpenReset(false);
  // const handleOpenReset = (user) => {
  //   setUser(user);
  //   setOpenReset(true);
  // };

  //HOOK DELETE BUTTON
  const [openDel, setOpenDel] = useState(false);
  const handleCloseDel = () => setOpenDel(false);
  const handleOpenDel = (user) => {
    setUser(user);
    setOpenDel(true);
    closeUserMenu();
  };

  //HOOK ADD AGENTE
  const [openAdd, setOpenAdd] = useState(false);
  const handleCloseAdd = () => {
    setOpenAdd(false);
    load(0);
  }
  const handleOpenAdd = () => {
    setOpenAdd(true);
    closeUserMenu();
  }

  let axiosConfig = {
    headers: {
      Authorization: "Bearer " + state.user.token,
    },
  };
  
  // const fetcher = (url) =>
  //   .then((res) => res.data.data);
  // const { data, error } = useSWR([`${process.env.REACT_APP_API_URL}/users`, state.success], fetcher);

  useEffect(() => {
    console.log({Agente: actualAgent})
    console.log(location.state)
    load(0);
  }, []);
  //style card

  const cards = [
      {
        id: 1,
        title: (
          <>
            <span> Clienti</span>
          </>
        ),
        description: (
          <>
            <GroupIcon sx={{ color: orange[500] }}/>
            <span> {location.state.agent.childs}</span>
          </>
        ),
      },
      {
        id: 2,
        title: (
          <>
            <span> Configurazioni</span>
          </>
        ),
        description: (
          <>
            <BuildIcon sx={{ color: orange[500] }}/>
            <span>{location.state.agent.configurations_count} </span>
          </>
        ),
      },
    ];
    const fullName = location?.state?.managerName;
    const nameAgent = location?.state?.agent?.full_name;
    const actualAgent = location?.state?.agent;
    const oldManager = location?.state?.manager;
    const goTo = (number) => {
      switch (number) {
        case 1:
         return push({
            path: 'clients',
            label: 'Clienti',
            state: {
              managerName: fullName,
              manager: oldManager,
              agentName: nameAgent,
              agent: actualAgent
            }
          });;
        case 2:
           return push({
            path: 'configurations',
            label: 'Configurazioni',
            state: {
              id: actualAgent.id,
              isRetail: false
            }
          });
          return navigate("configurations");
        default:
          return navigate("/configurations");
      }
    };
  //
  const load = async (page) => {
    setRows({...rows, isRefreshing: true});
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_URL}/users/${state.areaManager ? state.areaManager.id : state.user.id}/agents?count=${rows.pageSize}&page=${page}`, axiosConfig);
      if (res.data.success !== 1) throw res.data.message;

      let pageCount = Math.ceil(res.data.data.itemsCount / ITEMS_PER_PAGE);
      setRows({ ...rows, items: res.data.data.items, itemsCount: res.data.data.itemsCount, page: page, pageCount: pageCount, isRefreshing: false });
    }
    catch (e) {
      console.log(e);
      setRows({...rows, isRefreshing: false});
    }
  }

  const showUserMenu = (agent) => {
    document.querySelectorAll(`div.dropdown:not(div.dropdown_agent_${agent.id})`).forEach(e => {
      e.classList.remove("show");
      e.querySelector(`ul.dropdown-menu`).classList.remove("show");
    });
    
    let dropdown = document.querySelector(`div.dropdown_agent_${agent.id}`);
    let dropdownMenu = dropdown.querySelector(`ul.dropdown-menu`);

    dropdown.classList.toggle("show");
    dropdownMenu.classList.toggle("show");
  }

  const closeUserMenu = () => {
    document.querySelectorAll(`div.dropdown`).forEach(e => {
      e.classList.remove("show");
      e.querySelector(`ul.dropdown-menu`).classList.remove("show");
    });
  }

  const resetPassword = async (agent) => {
    //setLoading(true);
    let res = await axios.post(`${process.env.REACT_APP_API_URL}/users/generate-password`, {
      id: agent.id,
    }, axiosConfig);
      
    res.data.success == 1 && dispatch(baseActions.setSuccess(true));
    res.data.success === 1 && alert("La password è stata reimpostata con successo. L'utente riceverà un'email con la nuova password.");
      
    //setLoading(false);
    closeUserMenu();
  }

  const getScontistica = (agent) => {
    let scontistica = "-";
    if (agent.discount1 && agent.discount1 > 0) {
      //scontistica = agent.discount1
    }
    return scontistica;
  }

  const createQuickConfiguration = async () => {
    try {
      setRows({...rows, isRefreshing: true});

      let res = await configurationsService.createQuickConfiguration(state.user.token, {});
      dispatch(baseActions.clearStorage());
      dispatch(baseActions.setQuoteId(res.id));
      dispatch(baseActions.setCustomer({id: res.customer.id, lastName: res.customer.surname, firstName: res.customer.name, isServiceCustomer: true}));
      navigate("/products");
    } catch (e) {
      setRows({...rows, isRefreshing: false});
    }
  }

  const showAnonymousConfigurations = async (user) => {
    try {
      let serviceCustomerId = await customersService.findServiceCustomerId(state.user, user.id);
      if (!serviceCustomerId) {
        alert("Non ci sono ancora configurazioni disponibili.");
        return;  
      }
      dispatch(baseActions.setCustomer({id: serviceCustomerId, lastName: "Configurazioni", firstName: "Anonime", isServiceCustomer: true}));
      navigate("/configurations", { state: { parentUser: user } });      
    } catch (e) {
      console.log(e);
    }
  }
const theme = createTheme();

theme.typography.h3 = {
  fontSize: '1.2rem',
  '@media (min-width:600px)': {
    fontSize: '1.5rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '2.4rem',
  },
};
  if (!rows) return <Loading />;

  return (
    <I18n locale={state.locale}>
      <LayoutPage>
        <div style={{flex: "0 0 auto"}}>
          <TopBar />
          <div className={"d-flex p-3"}>
            <div className="d-flex flex-column" style={{ lineHeight: "1" }}>         
              <h2 className="h2 fw-bold">{location.state.agent.full_name}</h2>
                    <div role="presentation" onClick={handleClick}>
                     <Breadcrumbs aria-label="breadcrumb">
                              {stack.slice().reverse().map((item, index) => {
                                const isLast = index === stack.length - 1;
                                const isFirst = index === 0;

                                return (
                                  <Typography
                                    key={index}
                                    onClick={() => {
                                      if (!isLast) goToStack(index);
                                    }}
                                    sx={{
                                      cursor: isLast ? "default" : "pointer",
                                      color: isFirst ? "#df5b23" : isLast ? "text.primary" : "#212529",
                                      textDecoration: isLast ? "none" : "underline",
                                      display: "flex",
                                      alignItems: "center",
                                      '&:hover': {
                                        textDecoration: isLast ? "none" : "underline",
                                      },
                                    }}
                                  >
                                    {isFirst ? (
                                      <>
                                        <HomeIcon style={{ width: "1.1rem", height: "1.2rem", marginRight: 4 }} />
                                        Home
                                      </>
                                    ) : (
                                      item.label
                                    )}
                                  </Typography>
                                );
                              })}
                            </Breadcrumbs>
                    </div>
              </div>
          </div>
        </div>
        <div className="container-fluid">
        <div className="row justify-content-center">
              {cards.map((card, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                <Card key={card.id}>
                  <CardActionArea
                    onClick={() => goTo(card.id)}
                  >
                    <CardContent sx={{ height: '100%',color: 'black',justify:"center", }}>
                      <Typography variant="h5" component="div">
                        {card.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", fontSize: "2rem", fontWeight: "600", padding: "0.75rem 0" }}>
                        {card.description}
                      </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            color: 'black',
                            cursor: 'pointer',
                            marginTop: '0.75 rem'
                          }}
                        >
                          <div>
                            <Button variant="contained" size='small'>Visualizza tutto</Button>
                          </div>
                        </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </div>
              ))}
        </div>
        </div>
        {/* MODAL EDIT AGENTE */}
        <ModalEdit
          title={"Modifica agente"}
          open={openEdit}
          handleClose={handleCloseEdit}>
          <AgentiForm handleClose={handleCloseEdit} user={user} />
        </ModalEdit>
        <CustomizedSnackbars open={open} setOpen={setOpen} />

        {/* MODAL ADD */}
        <ModalEdit
          title={"Nuovo agente"}
          open={openAdd}
          handleClose={handleCloseAdd}>
          <AgentiForm handleClose={handleCloseAdd} />
        </ModalEdit>

        {/*  MODAL RESET PASSWORD*/}
        <ModalCustom
          title={"Reimposta password"}
          open={openReset}
          handleClose={handleCloseReset}>
          <ResetPass user={user} handleClose={handleCloseReset} />
        </ModalCustom>

        {/*  MODAL DELETE */}
        <ModalCustom
          title={"Sicuro di eliminarlo?"}
          open={openDel}
          handleClose={handleCloseDel}>
          <Typography variant="h5" component="div">
            I dati eliminati non potranno essere recuperati.
          </Typography>
          <Grid
            container
            spacing={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: 2,
            }}>
            <Grid
              item
              md={3}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <Button
                startIcon={<CheckIcon sx={{ fontSize: 28 }} color={"white"} />}
                onClick={() =>
                  axios
                    .delete(`${process.env.REACT_APP_API_URL}/users/${user.id}`, axiosConfig)
                    .then((res) => {
                      if (res.data.data === 1) {
                        dispatch(baseActions.setSuccess(true));
                        handleCloseDel();
                      } else {
                        alert("Ops...riprovare");
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                    })
                }
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1.5,
                  fontWeight: "bold",
                  fontSize: 16,
                }}
              >
                SI
              </Button>
            </Grid>
            <Grid
              item
              md={3}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                color={"secondary"}
                onClick={handleCloseDel}
                startIcon={<CloseIcon sx={{ fontSize: 28 }} color={"white"} />}
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1.5,
                  fontWeight: "bold",
                  fontSize: 16,
                  color: "white",
                }}
              >
                NO
              </Button>
            </Grid>
          </Grid>
        </ModalCustom>

        {rows.isRefreshing && <LoadingInternal />}
      </LayoutPage>
    </I18n>
  );
};

export default DashboardAgents;
